/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { transparent } = colors;

const select = {
  styleOverrides: {
    select: {
      display: "grid",
      alignItems: "center",
      padding: `0 ${pxToRem(12)} !important`,

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },

      // Enhanced multiselect styling
      "&[aria-expanded='true']": {
        "& .MuiSelect-icon": {
          transform: "rotate(180deg)",
        },
      },
    },

    // Improved multiple select display
    "&.MuiSelect-multiple": {
      "& .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: pxToRem(4),
        minHeight: pxToRem(20),
        paddingTop: pxToRem(14),
        paddingBottom: pxToRem(14),
      },
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    icon: {
      display: "none",
    },
  },
};

export default select;
